import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  RESET_CART,
  USER_ORDERS,
  USER_DETAILS,
  SET_PRODUCT_MINIMUM_VALUE,
  RESONATE_EXCLUSIVE_LIST,
  RESONATE_EXCLUSIVE_FILTER,
  SHOP_ONLINE_LIST,
  SHOP_ONLINE_FILTER,
  ADD_ITEMS_TO_CART,
  SET_USER_ID,
  SET_QR_CODE
} from "./actionTypes";



export const resonateExclusiveList = resonateExclusive => {
  return {
    type: RESONATE_EXCLUSIVE_LIST,
    resonateExclusive
  };
};

export const resonateExclusiveFilter = filterName => {
  return {
    type: RESONATE_EXCLUSIVE_FILTER,
    filterName
  };
};


export const shopOnlineList = shopOnline => {
  return {
    type: SHOP_ONLINE_LIST,
    shopOnline
  };
};

export const shopOnlineFilter = filterName => {
  return {
    type: SHOP_ONLINE_FILTER,
    filterName
  };
};

export const addItemsToCart = productId => {
  return {
    type: ADD_ITEMS_TO_CART,
    productId
  };
};

export const userDetails = user => {
  return {
    type: USER_DETAILS,
    user
  };
};

export const setProductMinimumValue = minValue => {
  return {
    type: SET_PRODUCT_MINIMUM_VALUE,
    minValue
  };
};

export const setUserQRCode = qrCode => {
  return {
    type: SET_QR_CODE,
    qrCode
  };
};

export const setUserId = userId => {
  return {
    type: SET_USER_ID,
    userId
  };
};

export const setOrderList = orders => {
  return {
    type: USER_ORDERS,
    orders
  };
};



export const addToCart = productId => {
  return {
    type: ADD_TO_CART,
    productId
  };
};

export const removeFromCart = productId => {
  return {
    type: REMOVE_FROM_CART,
    productId
  };
};

export const resetCart = () => {
  return {
    type: RESET_CART
  };
};
